import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function LinkIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49017 12.5059L12.5059 7.49017M8.7441 5.93137L11.0999 3.58023C11.8074 2.88425 12.7611 2.49599 13.7535 2.50003C14.7459 2.50407 15.6965 2.90008 16.3982 3.60181C17.0999 4.30353 17.4959 5.25411 17.5 6.24649C17.504 7.23887 17.1158 8.19265 16.4198 8.90006L14.0639 11.252M5.93137 8.7441L3.58023 11.0999C2.88425 11.8074 2.49599 12.7611 2.50003 13.7535C2.50407 14.7459 2.90008 15.6965 3.60181 16.3982C4.30353 17.0999 5.25411 17.4959 6.24649 17.5C7.23887 17.504 8.19265 17.1158 8.90006 16.4198L11.252 14.0639"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
